import React from "react";
import * as Icons from "lucide-react";
import useReveal from "../hooks/useReveal";
import { whyChoose } from "../mock";
import useBranding from "../hooks/useBranding";

const WhyChoose = () => {
  const [ref, inView] = useReveal();
  const b = useBranding();

  return (
    <section className="py-20 md:py-28 bg-[#f6f9fd] overflow-hidden">
      <div ref={ref} className="pp-container grid lg:grid-cols-2 gap-14 items-center">
        {/* Images + stat */}
        <div className={`relative pp-reveal ${inView ? "pp-in" : ""}`}>
          <div className="rounded-3xl overflow-hidden shadow-[0_30px_60px_-25px_rgba(13,27,42,0.45)]">
            <img src={whyChoose.image1} alt="Why choose PhotonPE" className="w-full h-[420px] object-cover" />
          </div>
          <div className="absolute -bottom-8 -right-4 w-48 rounded-2xl overflow-hidden border-8 border-white shadow-xl hidden md:block pp-float">
            <img src={whyChoose.image2} alt="PhotonPE team" className="w-full h-36 object-cover" />
          </div>
          <div className="absolute top-6 -left-4 md:left-6 bg-[#0D1B2A] text-white rounded-2xl px-6 py-4 shadow-xl">
            <div className="text-3xl md:text-4xl font-extrabold text-[#10B981]">{whyChoose.stat}</div>
            <div className="text-xs opacity-85 mt-1 max-w-[120px]">{whyChoose.statLabel}</div>
          </div>
        </div>

        {/* Cards */}
        <div className={`pp-reveal ${inView ? "pp-in" : ""}`} style={{ animationDelay: "0.15s" }}>
          <span className="inline-flex items-center gap-2 text-[#06B6D4] font-semibold uppercase tracking-wider text-sm">
            <span className="w-8 h-[2px] bg-[#06B6D4]" /> Why Choose {b.company_name}?
          </span>
          <h2 className="mt-4 text-3xl md:text-[42px] font-extrabold leading-[1.12] text-[#0D1B2A]">
            Why Choose <span className="pp-grad-text-orange">{b.company_name}?</span>
          </h2>

          <div className="mt-8 grid sm:grid-cols-2 gap-5">
            {whyChoose.items.map((item, i) => {
              const Icon = Icons[item.icon] || Icons.Sparkles;
              return (
                <div key={i} className="bg-white rounded-2xl p-6 pp-lift border border-slate-100">
                  <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4" style={{ background: "linear-gradient(135deg,#0D1B2A,#0EA5E9)" }}>
                    <Icon size={22} className="text-[#10B981]" />
                  </div>
                  <div className="font-bold text-[#0D1B2A]">{item.title}</div>
                  <p className="text-sm text-[#475569] mt-2 leading-relaxed">{item.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
